module.exports = __webpack_public_path__ + "static/media/emitirCertificado.abdee7ce.svg";